export default "__VITE_ASSET__sJDUSPWp__"